import styled from 'styled-components'

import CardTitle from '../../../../common/styles/CardTitle'
import useFormDistribution from '../hooks/useFormDistribution'
import LoadingBar from '../../../../common/LoadingBar'
import physicalBookIcon from '../../../../images/book-classifications/forms/physical-book.png'
import ebookIcon from '../../../../images/book-classifications/forms/ebook.png'
import audioBookIcon from '../../../../images/book-classifications/forms/audio-book.png'

const BookStatisticsFormCard = () => {
	const [data, total, isLoading] = useFormDistribution()

	const getPercent = (count: number): string => {
		if (total === 0) return '0%'
		const p = (count / total) * 100
		if (count === 0) return '0%'
		return `${p < 1 ? p.toFixed(1) : p.toFixed(0)}%`
	}

	const rows = [
		{label: '종이책', value: data?.physical ?? 0, icon: physicalBookIcon},
		{label: '전자책', value: data?.ebook ?? 0, icon: ebookIcon},
		{label: '오디오북', value: data?.audio ?? 0, icon: audioBookIcon},
	]

	return (
		<Container>
			
				<CardTitle icon={null} mb={0} title={'형태별 비율'} url={''} textSize={5}/>

				<Table>
					<tbody>
						{rows.map((row, i) => (
							<tr key={i}>
								<Th><FormIcon src={row.icon} alt={row.label}/> {row.label}</Th>
								<Td>
									{isLoading ? (
										<LoadingValue>
											<LoadingBar size={3}/>
										</LoadingValue>
									) : (
										<ValueContainer>
											<CountValue>{row.value}</CountValue>
											{getPercent(row.value) && <ExtraValue>{getPercent(row.value)}</ExtraValue>}
										</ValueContainer>
									)}
								</Td>
							</tr>
						))}
					</tbody>
				</Table>
			
		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;
`

const Table = styled.table`
	margin: 0;
	width: 100%;

	tbody {
		background-color: transparent !important;
	}

	tr {
		border-radius: 8px;

		&:hover {
			background-color: var(--hover-bg-color);
		}
	}
`

const FormIcon = styled.img`
	width: 22px;
	height: 22px;
	object-fit: contain;
	vertical-align: middle;
	margin-right: 6px;
`

const Th = styled.th`
	padding: 10px 8px;
	color: var(--text-color);
	font-size: 1.1rem;
	font-weight: normal;
	border-bottom: 1px solid var(--hover-bg-color);
`

const Td = styled.td`
	padding: 10px 8px;
	color: var(--text-color);
	border-bottom: 1px solid var(--hover-bg-color);
	text-align: right;
`

const LoadingValue = styled.div`
	height: 32px;
	display: flex;
	align-items: center;
`

const ValueContainer = styled.h5.attrs({className: 'd-flex flex-row justify-content-end'})`
	margin: 0;
	height: 32px;
`

const CountValue = styled.span`
	min-width: 40px;
	text-align: right;
	margin-right: 5px;
`

const ExtraValue = styled.div`
	padding-top: 7px;
	margin: 0;
	font-size: 14px;
	color: var(--sub-text-color);
	min-width: 45px;
	text-align: right;
`

export default BookStatisticsFormCard
